import React from "react";

// Barra con las categorías (disciplinas) de la asociación: categorias = [{ key, label }]
export const NavbarCategoriasAsociacion = ({ categorias = [], categoriaActiva, onSelect }) => {
  // Si todavía no hay categoría activa, se resalta la primera
  const activa = categoriaActiva != null ? String(categoriaActiva) : categorias[0]?.key;

  return (
    <nav className="barra-categorias">
      {categorias.map((categoria) => (
        <button
          key={categoria.key}
          type="button"
          className={categoria.key === activa ? "activo" : ""}
          onClick={() => onSelect(categoria.key)}
        >
          {categoria.label}
        </button>
      ))}
    </nav>
  );
};
